import Vue from 'vue'
import Vuex from 'vuex'
import config from '@/config'
import { webpTest, queryString } from '@/utils'

import axios from 'axios'
import mutations from '@/store/mutation-types'
import actions from '@/store/action-types'

import user from './modules/user'
import map from './modules/map'
import activity from './modules/activity'
import overview from './modules/overview'
import leaderboard from './modules/leaderboard'
import share from './modules/share'

Vue.use(Vuex)

const params = queryString(location.search)
const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    API_BASE_URL: `${config.api_base_url}/donation_activities/tfchina`,
    SHARE_API_BASE_URL: `${config.share_api_base_url}`,
    APP_URL: config.app_url,
    UNIVERSAL_LINK: config.universal_link,
    BASIC_DONATE_DURATION: 5,
    urlParams: params,
    ccPurchaseStatus: 0
  },
  getters: {
    supportWebp () {
      let support = false
      webpTest((boolean) => {
        support = boolean
      })
      return support
    }
  },
  mutations: {
    [ mutations.update.USER_INFORMATION ] (state, payload) {
      state.ccPurchaseStatus = payload.cc_purchase_status
    }
  },
  actions: {
    [ actions.fetch.USER_INFORMATION ] ({ commit, rootState }) {
      return axios.get(`${config.api_base_url}/users/info`, {
        params: {
          ...rootState.urlParams,
          fields: 'cc_purchase_status'
        }
      }).then(({ data }) => {
        commit(mutations.update.USER_INFORMATION, data)
      }).catch(error => {
        console.log(`${actions.fetch.USER_INFORMATION}: ${error}`)
      })
    }
  },
  modules: {
    user,
    map,
    activity,
    overview,
    leaderboard,
    share
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js